import { useAssessmentPlanFilterOptions } from "../../hooks/useAssessmentPlanFilterOptions";
import { useAiHubListFiltersStore } from "./aiHubListFiltersStore";

/**
 * Object Type / Sub-Type and dimension filters for AI Hub tagging result tabs.
 * Values live in `useAiHubListFiltersStore` so they survive detail-page unmount.
 */
export function useAiHubObjectScope(
  scope: "taggingResult" | "conditionalTaggingResult",
) {
  const { planTypesLoading, getObjectSubTypeOptions, objectTypeOptions } =
    useAssessmentPlanFilterOptions(undefined, {
      loadConcepts: false,
      configurableOnly: true,
    });
  const filters = useAiHubListFiltersStore((state) =>
    scope === "taggingResult"
      ? state.taggingResult
      : state.conditionalTaggingResult,
  );
  const setFilters = useAiHubListFiltersStore((state) =>
    scope === "taggingResult"
      ? state.setTaggingResult
      : state.setConditionalTaggingResult,
  );

  return {
    objectType: filters.objectType,
    objectSubType: filters.objectSubType,
    conceptCode: filters.conceptCode,
    conceptValue: filters.conceptValue,
    objectId: filters.objectId,
    setFilters,
    objectTypeOptions,
    planTypesLoading,
    getObjectSubTypeOptions,
  };
}
